var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('div',{staticClass:"owal-splitview__container"},[_c('div',{staticClass:"owal-splitview__master-panel"},[_vm._t("master")],2),_c('div',{staticClass:"owal-splitview__detail-panel"},[_c('div',{staticClass:"owal-splitview__detail-slot"},[_vm._t("detail")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }